import 'leaflet'

const BaseIcon = L.Icon.extend({
  options: {
    /*
        iconType: : (String)
        iconUrl: (String)
        iconAnchor: (Point)
        popupAnchor: (Point)
        */
  },

  initialize: function (options) {
    L.Util.setOptions(this, options)
  },

  getVueComponent: function () {
    console.error('Describe getVueComponent')
    return null
  },

  createIcon: function () {
    let div = document.createElement('div')
    let childDiv = document.createElement('div')

    div.appendChild(childDiv)
    let el = this.getVueComponent()
    el.injectConf(this.options)
    el.$mount(childDiv)
    this.vueEl = el

    return div
  },

  createShadow: function () {
    return null
  },
})

export default BaseIcon
